module.exports = __webpack_public_path__ + "static/media/under-dev-txt.f9d67492.png";